import SysInfo from '../model/SysInfo';
import {LoginApi} from 'tplus-api';
import TemplateUtil from '../../util/TemplateUtil';


class LoginStore{

  static async setLoginInfo(){
    
    if(TemplateUtil.tempalteExist()){
      //若有模板 不是一次进入 可以同步取模板等信息
      return Promise.all([SysInfo.setSysInfo(),
        SysInfo.setOrderFunction(),
        SysInfo.GetWhetherEnableSaleSingleFullGift(),
        SysInfo.getSaleDeliveryInvoiceType(),
        SysInfo.GetSignInOption(),
      ]).then(result=>{
        console.log('result=======',result);
      }).catch(error=>{
        console.log('error========',error);
      })
    }else{
       //若无模板 是一次进入 异步取模板等信息
      return Promise.all([SysInfo.setSysInfo(),
        SysInfo.setAccountInfos(),
        SysInfo.setOrderFunction(),
        SysInfo.setVoucherWorkFlow(),
        SysInfo.GetWhetherEnableSaleSingleFullGift(),
        SysInfo.getSaleDeliveryInvoiceType(),
        SysInfo.GetSignInOption(),
        LoginStore.getJsTicket(),
        TemplateUtil.refreshTemplate()
      ]).then(result=>{
        console.log('result=======',result);
      }).catch(error=>{
        console.log('error========',error);
      })
    }
  }

  static async getJsTicket(){
    try{
      const jsTicket = await LoginApi.getSignature();
      if(true === jsTicket.result){
        window.localStorage.agentId = jsTicket.agentId;
        window.localStorage.timeStamp = jsTicket.timeStamp;
        window.localStorage.signature = jsTicket.signature;
      }
    }catch(e){
      alert('js接口初始化异常'+e);
    }
  }

}

export default LoginStore;
